import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { getToken } from '../../lib';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton'
import { ALertHeaderText } from '../../components/Seminars/styles'
import config from '../../config/config'

class ManageIpAddress extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ipAddresses: '',
      errorMsg: null,
      success: false
    }
  }

  async componentDidMount() {
    const token = getToken();
    fetch(`${config.URI}/api/v1/get_fvcontract`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
    .then((temp) => temp.json())
    .then(res => {
      if (res.status && res.status === 'success') {
        if (res.data.domain) {
          if(!res.data.domain.enable_ipaddress_filter) 
            window.location = '/';

          this.setState({ipAddresses: res.data.domain.whitelisted_ip_addresses.join('\n')})
        }
      }
    })
    .catch((error) => {
      console.error(error)
    })
  }

  validateIps = () => {
    let returnVal = true;
    let ips = this.state.ipAddresses.trim();
    if (ips != "") {
      let ipArray = ips.split('\n');
      let invalidIps = [];
      ipArray.forEach(function (value) {
        let validated = (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value))
        if (!validated)
        {
          returnVal = false;
          invalidIps.push(value);
        }  
      });
      this.setState({errorMsg: invalidIps});
    }
    return returnVal;
  }

  saveIpAddresses = () => {
    if (this.validateIps()) {
      this.setState({errorMsg: null});
      const token = getToken();
      this.props.updateIpAddresses(token, this.props.domainId, this.state.ipAddresses);
      this.setState({success: true});
    }
  }

  render() {
    return (
      <Paper className="pa3" style={{textAlign:"center"}}>
        <div style={{textAlign:'center', overflow: 'hidden auto', height: '70vh'}}>
          <h3 className="pr2" style={{ fontSize: 24, color: '#4ac6c4',top:'14px',position: 'relative' }}>
            <FormattedMessage id="manageIpAddress.heading" />
          </h3>
          <ALertHeaderText>
            {this.state.errorMsg && <p  style={{fontSize: '13px',fontWeight:'bold', color: 'red'}}><FormattedMessage id="manageIpAddress.invalidIps" /></p> }
            {this.state.success && <p  style={{fontSize: '13px',fontWeight:'bold', color: 'green'}}><FormattedMessage id="CreateDomainLabel.sentInformation" /></p> }
          </ALertHeaderText>
          <div>
            <textarea
              style={{
                width: (this.props.view === 'mobile' || this.props.view === 'sm-mobile') ? '80vw' : '20vw',
                backgroundColor: '#FAFAFA',
                height: (this.props.view === 'mobile' || this.props.view === 'sm-mobile') ? '30vw' : '30vw',
              }}
              placeholder="xxx.xxx.xxx.xxx&#10;xxx.xxx.xxx.xxx"
              value={this.state.ipAddresses} onChange={(e) => this.setState({ ipAddresses: e.target.value })}
            >
              
            </textarea>
          </div>

          <RaisedButton
            className="ml3"
            backgroundColor="#FCCE42"
            type="button"
            onClick={this.saveIpAddresses}
            label={<FormattedMessage id="user.save"/>}
          />
        </div>
        
      </Paper>
    )
  }
}

export default ManageIpAddress



// WEBPACK FOOTER //
// src/routes/ManageIpAddress/ManageIpAddress.js